import React from "react";
import { TFunction } from "i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { ERROR_TEXT_STYLE } from "../constants";

type Props = {
    auresKonnectGroup: string;
    setAuresKonnectGroup: (v: string) => void;
    setInputGroup: (v: boolean) => void;
    setIsEdited: (v: boolean) => void;
    inputGroup: boolean;
    isExist: boolean;
    choiceFidelity: string;
    dataFidelity: any;
    isTest: boolean;
    isCentralizationActive: boolean;
    isConsultModalOpened: boolean;
    isConsult?: boolean;
    t: TFunction;
};

export default function GroupInput({
    auresKonnectGroup,
    setAuresKonnectGroup,
    setInputGroup,
    setIsEdited,
    inputGroup,
    isExist,
    choiceFidelity,
    dataFidelity,
    isTest,
    isCentralizationActive,
    isConsultModalOpened,
    isConsult,
    t,
}: Props) {
    const isNotAllowed =
        dataFidelity?.Id !== undefined ||
        isTest ||
        (isCentralizationActive && isConsultModalOpened);

    const existMessage = choiceFidelity.startsWith(t("Fidelity Softavera"))
        ? t("Loyalty type and group combination already exists")
        : t("The display name, fidelity type combination already exists");

    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <StyledLabel className="required__clz mt-3" htmlFor="name">
                {t("Group")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-franchise-group-input"
                autoComplete="off"
                id="Group"
                name="Group"
                placeholder={t("Write")}
                type="text"
                onChange={(e: any) => {
                    setAuresKonnectGroup(e.target.value);
                    setInputGroup(false);
                    setIsEdited(true);
                }}
                className={classnames({
                    input__clz: inputGroup || isExist,
                    "not-allowed-icon__clz": isNotAllowed,
                })}
                value={auresKonnectGroup}
            />
            {inputGroup ? (
                <div style={ERROR_TEXT_STYLE}>{t("Please enter a group")}</div>
            ) : null}
            {isExist ? (
                <div style={ERROR_TEXT_STYLE}>{existMessage}</div>
            ) : null}
        </AvGroup>
    );
}
